<template>
  <div class="form-box" :style="{'width': boxWidth}">
    <div class="welcome">&nbsp;{{ title }}</div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    width: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      boxWidth: ''
    };
  },
  mounted() {
    this.boxWidth = this.width + 'px';
  },
  methods: {},
};
</script>

<style lang='less' scoped>
@import "../../../style/mixin.less";
.form-box {
  box-shadow: 0px 3px 14px 0px rgba(59, 59, 59, 0.3);
  .flex(flex-start, column, center);
  .welcome {
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #1f8df2;
    margin: 40px 0;
    letter-spacing: 10px;
    .flex(center);
  }
  padding: 0 20px;
  // min-height: 400px;
  background: rgba(255, 255, 255, 1);
  border-radius: 15px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  // transform: translate(-50%, -50%);
  // padding: 0 85px;
  padding-bottom: 40px;
  box-sizing: border-box;
  i {
    color: rgba(31, 141, 242, 0.5);
  }
  .login-form{
    width: 300px;
  }
}
</style>